import React from "react";
import { NavLink } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import Logo from "./logo.png";
import { GoBell } from "react-icons/go";
// import BusinessListFromHeader from "./businessListFromHeader";
import { Avatar } from "@mui/material";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
const SideBarHeader = ({ alluserdata, callAccepted }) => {
  let history = useHistory();
  const location = useLocation();

  const handleGoToProfile = () => {
    if (callAccepted?.accepted) {
      toast.error("Not allowed during call");
    } else {
      history.push("/Profile");
    }
  };

  return (
    <>
      <div
        className=" pt-1 pb-2 background_nav1_header"
        style={{
          position: "fixed",
          width: "100vw",
          zIndex: 99999999,
        }}
      >
        <div className="d-flex justify-content-between align-item-center">
          <div className="">
            <div className="">
              <div className="mx-2 ">
                <Link to="/buzzcom">
                  <img
                    className="img-fluid"
                    src={Logo}
                    alt="kdsnda"
                    style={{
                      cursor: "pointer",
                      height: "1.8rem",
                      width: "1.8rem",
                    }} // Change cursor on hover
                  />
                </Link>
              </div>
            </div>
          </div>
          {location.pathname.includes("/terms") ||
          location.pathname.includes("/contact-us") ||
          location.pathname.includes("/privacy") ? null : (
            <div className="d-flex">
              <div className="d-flex">
                <div className="pt-1">
                  <GoBell
                    fontSize={18}
                    color="#fff"
                    alt="np-data"
                    src="/images/bell.svg"
                  />
                </div>
                &nbsp; &nbsp;
                <div className="pt-1 pe-4">
                  {/* <TfiSettings
               fontSize={19}
               color="#fff" */}
                  <img alt="np-data" src="/images/setting.svg" />
                </div>
                <div
                  className="pt-1 pe-4 "
                  onClick={() => {
                    history.push("/contact-us");
                  }}
                >
                  {/* <TfiSettings
               fontSize={19}
               color="#fff" */}
                  <img
                    alt="np-data"
                    src="/images/contact-us.png"
                    className=""
                    width="20px"
                    height="20px"
                  />
                </div>
                <div className="vl mt-md-0 me-md-3 pb-1" />
              </div>

              <div className=" pe-3 pt-md-0 section avt-sec">
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={handleGoToProfile}
                >
                  {alluserdata?.imageURL ? (
                    <img
                      className=" width_profile_header"
                      src={`https://1864597015.rsc.cdn77.org/consentformattachments/images/staging/${alluserdata?.imageURL}`}
                      alt="noimage"
                      width="20px"
                      height="20px"
                    />
                  ) : (
                    <Avatar
                      sx={{ width: "2rem", height: "2rem" }}
                      //  src=
                      //  {user.imageURL}
                    />
                  )}
                  {/* <button className="btn btn-warning">Profile</button> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default SideBarHeader;
